function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0.5 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M7,1.3c1.9,0,2.1,0,2.9,0.1c1.9,0.1,2.8,1,2.9,2.9C12.8,5,12.8,5.1,12.8,7s0,2.1-0.1,2.8 c-0.1,1.9-1,2.8-2.9,2.9c-0.8,0.1-0.9,0.1-2.9,0.1c-1.9,0-2.1,0-2.8-0.1c-1.9-0.1-2.8-1-2.9-2.9C1.3,9,1.3,8.9,1.3,7s0-2.1,0.1-2.8 c0.1-1.9,1-2.8,2.9-2.9C4.9,1.3,5.1,1.3,7,1.3z M7,0C5.1,0,4.8,0,4.1,0.1c-2.6,0.1-4,1.5-4.1,4.1C0,4.8,0,5.1,0,7s0,2.2,0.1,2.9 c0.1,2.6,1.5,4,4.1,4.1C4.8,14,5.1,14,7,14s2.2,0,2.9-0.1c2.6-0.1,4-1.5,4.1-4.1C14,9.2,14,8.9,14,7s0-2.2-0.1-2.9 c-0.1-2.6-1.5-4-4.1-4.1C9.2,0,8.9,0,7,0z M7,3.4C5,3.4,3.4,5,3.4,7S5,10.6,7,10.6S10.6,9,10.6,7S9,3.4,7,3.4z M7,9.3 C5.7,9.3,4.7,8.3,4.7,7S5.7,4.7,7,4.7S9.3,5.7,9.3,7S8.3,9.3,7,9.3z M10.7,2.4c-0.5,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8 c0.5,0,0.8-0.4,0.8-0.8S11.2,2.4,10.7,2.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.e3dbc316.svg";
export { ForwardRef as ReactComponent };